
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(5(45|67|77)|(|1)22|146|889)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
